// extracted by mini-css-extract-plugin
export var button = "edit-page-button-module--button--331b2";
export var float = "edit-page-button-module--float--f1848";